import React, { createContext, useContext } from 'react';
import PropTypes from 'prop-types';
import MembershipShow from '../components/MembershipShow';

const MembershipShowContext = createContext();

export function useMembershipShowContext() {
  return useContext(MembershipShowContext);
}

const MembershipShowApp = (props) => (
  <MembershipShowContext.Provider value={props}>
    <MembershipShow />
  </MembershipShowContext.Provider>
);

MembershipShowApp.propTypes = {
  csrfToken: PropTypes.string.isRequired,
  team: PropTypes.shape({ id: PropTypes.number }).isRequired,
  membership: PropTypes.shape({ status: PropTypes.string }).isRequired,
  fan: PropTypes.shape({ id: PropTypes.number }),
  membershipProductPath: PropTypes.string.isRequired,
  membershipProductsPath: PropTypes.string.isRequired,
  fanPath: PropTypes.string,
  settingsPath: PropTypes.string.isRequired,
  invoicesDatatablePath: PropTypes.string.isRequired,
  pendingGift: PropTypes.shape({
    first_name: PropTypes.string,
    last_name: PropTypes.string,
    email: PropTypes.string,
    accept_deadline: PropTypes.string,
    sends_on: PropTypes.string,
  }),
  giftStatus: PropTypes.string,
  giftable: PropTypes.bool,
  sendGiftPath: PropTypes.string,
  cancelGiftPath: PropTypes.string,
  canManageGift: PropTypes.bool,
};

MembershipShowApp.defaultProps = {
  fan: null,
  fanPath: null,
  pendingGift: null,
  giftStatus: null,
  giftable: false,
  sendGiftPath: null,
  cancelGiftPath: null,
  canManageGift: false,
};

export default MembershipShowApp;
